import React, { useState } from "react";
import "./Product.scss";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { useLocation, useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/cartReducer";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import axios from "axios";
import FeaturedProducts from "../../components/FeaturedProducts/FeaturedProducts";
import Loading from "../../components/loading/Loading";
import { FaCircle } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";
import { useContext } from "react";

const Product = () => {
  const { buyer } = useContext(AuthContext);
  const products = useSelector((state) => state.cart.products);
  const { id, slug } = useParams();
  const location = useLocation();
  const [selectImage, setSelectImage] = useState("img");
  const [quantity, setQuantity] = useState(5);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState([]);

  useEffect(() => {
    if (!id) return;

    const getProduct = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/get-singal-product", {
          params: { id },
        });
        setProduct(response.data);

        // ✅ set first photo as default
        if (response.data?.proPhotos?.length > 0) {
          setSelectImage(response.data.proPhotos[0]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    getProduct();
  }, [id]);

  const getQuantityInCart = () => {
    const cartItem = products.find((item) => item.id);
    return cartItem
      ? {
          id: cartItem.id,
          max_order_value: cartItem.max_order_qut,
          quantity: cartItem.quantity,
        }
      : { id: null, max_order_value: 2, quantity: 2 }; // Default values for quantity if no item is found
  };

  const cartData = getQuantityInCart();

  const flashSaleItemsInCart = products.filter(
    (product) => product.flash_sale === true
  ).length;

  // find special price for this buyer
  const customerSpecialPrice = product.customerPrice?.find(
    (cp) => cp.customerId === buyer?.buyerId
  );

  

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="product">
          {loading ? (
            <Loading />
          ) : (
            <div className="product_card">
              <div className="left">
                {/* Thumbnails */}
                <div className="images">
                  {product?.proPhotos?.map((photo, index) => (
                    <img
                      key={index}
                      src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${photo}`}
                      alt={`Product ${index + 1}`}
                      onClick={() => setSelectImage(photo)}
                    />
                  ))}
                </div>

                {/* Main Image */}
                <div className="mainImg">
                  <img
                    src={`${process.env.REACT_APP_DOC_VIEW_LINK}/${
                      selectImage || product?.proPhoto?.[0]
                    }`}
                    alt="Selected Product"
                  />
                </div>
              </div>

              <div className="right">
                {/* <div>
                  <span
                    style={{
                      backgroundColor: "#53dc1f",
                      padding: "5px 20px",
                      color: "white",
                      fontSize: "18px",
                      borderRadius: "5px",
                    }}
                  >
                    {product.discount}% Off
                  </span>
                </div> */}
                <div className="pro_heading">
                  <h4>{product?.name}</h4>
                  <div className="sku_wrp">
                    <small>
                      <em>SKU: </em> {product?.lrCode}
                    </small>
                    <small>|</small>
                    <small>
                      <FaCircle
                        style={{ marginBottom: "3px" }}
                        size={12}
                        color="#53dc1f"
                      />{" "}
                      InStock
                    </small>
                    <small>|</small>
                    <small>
                      {customerSpecialPrice ? (
                        <span className="price">
                          <em>Weight: </em> 1 KG
                          {/* {customerSpecialPrice.unitOfMeasureCode} */}
                        </span>
                      ) : (
                        <span className="price">
                          <em>Weight: </em> 1 KG
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="pro_price">
                  <span className="price">
                    {customerSpecialPrice ? (
                      <span className="price">
                        {customerSpecialPrice.price?.toFixed(2)} AED
                      </span>
                    ) : (
                      <span className="price">
                        {product.price?.toFixed(2)} AED
                      </span>
                    )}
                  </span>
                  <br />
                  <div className="descrip">
                    <span>Description</span>
                    <p>{product.description}</p>
                  </div>
                </div>

                <div className="weight_chart">
                  <div>
                    <span>Per pieces </span>
                  </div>
                  <div className="we_in">
                    <div className="w_in">
                      <span>Weight</span>
                      <hr />
                      <p>{product.weight}</p>
                    </div>
                    <div className="w_in">
                      <span>Per kg</span>
                      <hr />
                      <p>{product.perKg}</p>
                    </div>
                    <div className="w_in">
                      <span>Height</span>
                      <hr />
                      <p>{product.height}</p>
                    </div>
                    <div className="w_in">
                      <span>Width</span>
                      <hr />
                      <p>{product.width}</p>
                    </div>
                    <div className="w_in">
                      <span>Length</span>
                      <hr />
                      <p>{product.length}</p>
                    </div>
                  </div>
                </div>
                <div className="min_wrp">
                  <span>
                    Minimum Order Quantity: <em> 5 kg per order</em>{" "}
                  </span>
                </div>

                <div className="pro_chk_sec">
                  <div className="quantity">
                    <button
                      className="q_bt"
                      onClick={() =>
                        setQuantity((prev) => (prev <= 5 ? 5 : prev - 5))
                      }
                    >
                      -
                    </button>

                    <div className="qut_nu">
                      <span>{quantity} kg</span>
                    </div>

                    <button
                      className="q_bt"
                      onClick={() => setQuantity((prev) => prev + 5)}
                    >
                      +
                    </button>
                  </div>

                  <div className="bt_wrp">
                    <div>
                      {" "}
                      {customerSpecialPrice ?(<span>{(quantity * customerSpecialPrice.price).toFixed(2)} AED</span>):(<span>{(quantity * product.price).toFixed(2)} AED</span>)}
                      
                    </div>
                    <div
                      className="add"
                      onClick={() => {
                        dispatch(
                          addToCart({
                            id: product._id,
                            title: product.name,
                            desc: product.desc,
                            weight: product.weight,
                            price: customerSpecialPrice
                              ? customerSpecialPrice?.price
                              : product?.price,
                            img: product.proPhotos[0],
                            quantity: quantity,
                          })
                        );
                        toast.success("Product added to cart!");
                      }}
                    >
                      <AddShoppingCartIcon />
                      ADD TO CART
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;
